import { createContext } from 'react';

export const ClientSelectionContext = createContext(null);
